import { useMemo, useState } from "react"

import { useNode } from "@craftjs/core"
import { get, set } from "lodash"
import { XIcon } from "lucide-react"
import { DefaultPopover, Button, Separator } from "twyne-new.ui"

import { useResponsive, useUtilities } from "@/modules/cms/views/post/components/builder/context"

import { resetSingleProp } from "../ClearProp"

import { useToolbar } from "./context"

export default function Reset({ trigger, defaultProps = {}, allKeys = [], ignoreResetProps = [] }) {
  const [open, setOpen] = useState(false)
  const { useChangeOpenPopover } = useToolbar()
  useChangeOpenPopover({ open, value: 'resetProps' })

  const { selectedUtilities, utilitiesParsed, setSelectedUtilities } = useUtilities()
  const { device } = useResponsive()

  const { actions: { setProp }, props } = useNode(({ data: { props: { properties } } }) => ({ props: properties }))

  const variantProps = useMemo(() => {
    const variantProps = {}
    for (const prop of ignoreResetProps) {
      set(variantProps, prop, get(props, prop))
    }
    return variantProps
  }, [ignoreResetProps, props])

  const handleClearAll = () => {
    setProp(props => set(props, 'properties', { ...defaultProps.properties, ...variantProps }))
    setOpen(false)
    setSelectedUtilities(prev => [...prev])
  }

  const handleClearUtilities = () => {
    let reseted
    if (device === 'mobile') {
      reseted = resetSingleProp({ props, keys: allKeys, device, defaultProps: { ...defaultProps.properties, ...variantProps }, utilitiesParsed })
    } else {
      reseted = resetSingleProp({ props, keys: allKeys, device: 'desktop', defaultProps: { ...defaultProps.properties, ...variantProps }, utilitiesParsed })
      reseted = resetSingleProp({ props: reseted, keys: allKeys, device: 'mobile', defaultProps: { ...defaultProps.properties, ...variantProps }, utilitiesParsed })
    }

    setProp(props => set(props, 'properties', reseted))
    setOpen(false)
    setSelectedUtilities(prev => [...prev])
  }

  return <>
    <DefaultPopover
      trigger={trigger}
      triggerProps={{ asChild: true }}
      contentProps={{ side: 'bottom' }}
      wrapperProps={{ open, onOpenChange: setOpen }}
    >
      <div className='flex justify-between items-center font-bold'>
        Reset properties
        <XIcon size='16' className='cursor-pointer' onClick={() => setOpen(false)} />
      </div>
      <Separator className='m-0 my-2' />

      <p>Are you sure you want reset to the default properties for this component?</p>

      <div className='flex flex-col gap-2 mt-2'>
        <Button size='sm' color="danger" variant='outline' onClick={handleClearAll} block>
          Reset for all properties
        </Button>
        {selectedUtilities.length || device === 'mobile' ? <>
          <Button size='sm' color="danger" variant='light' onClick={handleClearUtilities} block className='flex justify-between gap-1 flex-col items-center flex-wrap'>
            Reset for current utilities
            <span className='text-sm font-bold whitespace-normal'>({device === 'mobile' ? 'mobile' : ''}{device === 'mobile' && selectedUtilities.length ? '>' : ''}{selectedUtilities.join(':')})</span>
          </Button>
        </> : null}
      </div>
    </DefaultPopover>
  </>
}
